var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "l8meriv5wa",
    d: "M9.167 18.333L9.167 12.833 12.833 12.833 12.833 18.333 17.417 18.333 17.417 11 20.167 11 11 2.75 1.833 11 4.583 11 4.583 18.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1agtrrgxrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l8meriv5wa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    mask: "url(#1agtrrgxrb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-11.917 -11.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-home.0d278ef2.svg";
export { ForwardRef as ReactComponent };